import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Superseded by /my-profile (the real, MySQL-backed profile editor added in
 * the candidate dashboard migration) — this page used to save straight into
 * a dead localStorage key with no auth gate at all, so it's now just a
 * redirect rather than a second, disconnected copy of the same form.
 */
export const Route = createFileRoute("/profile/")({
  beforeLoad: () => {
    throw redirect({ to: "/my-profile" });
  },
});
